module.exports = __webpack_public_path__ + "img/notfound.2c28319c.png";